import React from 'react'
import { Translation } from 'react-i18next'

const Account = React.lazy(() => import('./views/account/Account'))
const AccountEdit = React.lazy(() => import('./views/account/AccountEdit'))
const Calendar = React.lazy(() => import('./views/certificate/Calendar'))
const Certificate = React.lazy(() => import('./views/certificate/Certificate'))
const CertificateEdit = React.lazy(() => import('./views/certificate/CertificateEdit'))
const CompanyAccounts = React.lazy(() => import('./views/dictionary/CompanyAccounts'))
const Course = React.lazy(() => import('./views/dictionary/Course'))
const DashboardAdmin = React.lazy(() => import('./views/dashboard/Admin'))
const DashboardInstructor = React.lazy(() => import('./views/dashboard/Instructor'))
const DashboardMaster = React.lazy(() => import('./views/dashboard/Master'))
const DashboardParent = React.lazy(() => import('./views/dashboard/Parent'))
const Instructors = React.lazy(() => import('./views/dictionary/Instructors'))
const InstructorMove = React.lazy(() => import('./views/account/InstructorMove'))
const InstructorTop = React.lazy(() => import('./views/dashboard/InstructorTop'))
const KnowledgeBase = React.lazy(() => import('./views/dictionary/KnowledgeBase'))
const MasterMove = React.lazy(() => import('./views/account/MasterMove'))
const Resale = React.lazy(() => import('./views/resale/Resale'))
const ResaleStats = React.lazy(() => import('./views/resale/ResaleStats'))
const SalesStats = React.lazy(() => import('./views/order/SalesStats'))
const Seminar = React.lazy(() => import('./views/certificate/Seminar'))
const SeminarCertificate = React.lazy(() => import('./views/certificate/SeminarCertificate'))
const Storage = React.lazy(() => import('./views/account/Storage'))
const Order = React.lazy(() => import('./views/order/Order'))
const OtpTable = React.lazy(() => import('./views/account/OtpTable'))
const PrivacyTable = React.lazy(() => import('./views/account/PrivacyTable'))
const ReportDownload = React.lazy(() => import('./views/dashboard/Download'))
const Team = React.lazy(() => import('./views/dictionary/Team'))
const TgChannels = React.lazy(() => import('./views/dictionary/TgChannels'))

const routes = {
  ADMIN: [
    { path: '/', exact: true, name: <Translation>{(t) => t('home')}</Translation> },
    {
      path: '/certificate',
      name: 'Сертификаты',
      element: Certificate,
    },
    {
      path: '/certificate/create',
      name: 'Создание',
      element: CertificateEdit,
    },
    {
      path: '/course',
      name: 'Курсы',
      element: Course,
    },
    {
      path: '/dashboard',
      name: 'Панель администратора',
      element: DashboardAdmin,
    },
    {
      path: '/profile',
      name: 'Профиль',
      element: AccountEdit,
    },
    {
      path: '/report/download',
      name: 'Скачать отчёт',
      element: ReportDownload,
    },
    {
      path: '/report/instructor',
      name: 'Отчёт инструктора',
      element: DashboardInstructor,
    },
    {
      path: '/report/instructor/top',
      name: 'Топ инструкторов',
      element: InstructorTop,
    },
    {
      path: '/report/parent',
      name: 'Отчёт наставника',
      element: DashboardParent,
    },
    {
      path: '/report/master',
      name: 'Профиль мастера',
      element: DashboardMaster,
    },
    {
      path: '/seminar',
      name: 'Список мероприятий',
      element: Seminar,
    },
    {
      path: '/seminar/certificate',
      name: 'Участники мероприятия',
      element: SeminarCertificate,
    },
    {
      path: '/user',
      name: 'Контакты',
      element: Account,
    },
    {
      path: '/user/:accountId/edit',
      name: 'Редактирование',
      element: AccountEdit,
    },
    {
      path: '/user/master_move',
      name: 'Переместить мастеров',
      element: MasterMove,
    },
    {
      path: '/user/instructor_move',
      name: 'Переместить инструкторов',
      element: InstructorMove,
    },
    {
      path: '/user/OTP_table',
      name: 'Таблица OTP',
      element: OtpTable,
    },
    {
      path: '/user/Privacy_table',
      name: 'Согласия',
      element: PrivacyTable,
    },
    {
      path: '/order',
      name: 'Заказы',
      element: Order,
    },
    {
      path: '/sales/stats',
      name: 'Статистика продаж 1С',
      element: SalesStats,
    },
    {
      path: '/seminar/calendar',
      name: 'Планер',
      element: Calendar,
    },
    {
      path: '/team',
      name: 'Команды',
      element: Team,
    },
    {
      path: '/instructors',
      name: 'Инструкторы',
      element: Instructors,
    },
    {
      path: '/resale',
      name: 'Продажи',
      element: Resale,
    },
    {
      path: '/resale/stats',
      name: 'Статистика продаж',
      element: ResaleStats,
    },
    {
      path: '/storage',
      name: 'Личный диск',
      element: Storage,
    },
    {
      path: '/storage/:accountId/:folderUuid',
      name: 'Личный диск',
      element: Storage,
    },
    {
      path: '/knowledge_base',
      name: 'База знаний',
      element: KnowledgeBase,
    },
    {
      path: '/knowledge_base/:folderUuid',
      name: 'База знаний',
      element: KnowledgeBase,
    },
    {
      path: '/knowledge_base/:trash',
      name: 'База знаний',
      element: KnowledgeBase,
    },
    {
      path: '/accounts',
      name: 'Сотрудники компании',
      element: CompanyAccounts,
    },
  ],
  INSTRUCTOR: [
    { path: '/', exact: true, name: <Translation>{(t) => t('home')}</Translation> },
    {
      path: '/dashboard',
      name: 'Отчёт инструктора',
      element: DashboardInstructor,
    },
    {
      path: '/report/instructor/top',
      name: 'Топ инструкторов',
      element: InstructorTop,
    },
    {
      path: '/profile',
      name: 'Профиль',
      element: AccountEdit,
    },
    {
      path: '/user',
      name: 'Контакты',
      element: Account,
    },
    {
      path: '/user/:accountId/edit',
      name: 'Редактирование',
      element: AccountEdit,
    },
    // {
    //   path: '/user/create',
    //   name: 'Создание',
    //   element: AccountEdit,
    // },
    {
      path: '/certificate',
      name: 'Сертификаты',
      element: Certificate,
    },
    {
      path: '/seminar/certificate',
      name: 'Участники мероприятия',
      element: SeminarCertificate,
    },
    {
      path: '/certificate/create',
      name: 'Подбор',
      element: CertificateEdit,
    },
    {
      path: '/seminar',
      name: 'Список мероприятий',
      element: Seminar,
    },
    {
      path: '/seminar/calendar',
      name: 'Планер',
      element: Calendar,
    },
    {
      path: '/order',
      name: 'Заказы',
      element: Order,
    },
    {
      path: '/resale',
      name: 'Продажи',
      element: Resale,
    },
    {
      path: '/resale/stats',
      name: 'Статистика продаж',
      element: ResaleStats,
    },
    {
      path: '/storage',
      name: 'Личный диск',
      element: Storage,
    },
    {
      path: '/storage/:accountId/:folderUuid?',
      name: 'Личный диск',
      element: Storage,
    },
    {
      path: '/storage/trash/:trashId',
      name: 'Корзина',
      element: Storage,
    },
    {
      path: '/knowledge_base',
      name: 'База знаний',
      element: KnowledgeBase,
    },
    {
      path: '/knowledge_base/:folderUuid',
      name: 'База знаний',
      element: KnowledgeBase,
    },
    {
      path: '/tgchannels',
      name: 'Telegram каналы',
      element: TgChannels,
    },
  ],
  PARENT: [
    { path: '/', exact: true, name: <Translation>{(t) => t('home')}</Translation> },
    {
      path: '/dashboard',
      name: 'Отчёт наставника',
      element: DashboardParent,
    },
    {
      path: '/report/instructor/top',
      name: 'Топ инструкторов',
      element: InstructorTop,
    },
    {
      path: '/profile',
      name: 'Профиль',
      element: AccountEdit,
    },
    {
      path: '/user',
      name: 'Контакты',
      element: Account,
    },
    {
      path: '/user/:accountId/edit',
      name: 'Редактирование',
      element: AccountEdit,
    },
    // {
    //   path: '/user/create',
    //   name: 'Создание',
    //   element: AccountEdit,
    // },
    {
      path: '/certificate',
      name: 'Сертификаты',
      element: Certificate,
    },
    {
      path: '/seminar/certificate',
      name: 'Участники мероприятия',
      element: SeminarCertificate,
    },
    {
      path: '/certificate/create',
      name: 'Подбор',
      element: CertificateEdit,
    },
    {
      path: '/seminar',
      name: 'Список мероприятий',
      element: Seminar,
    },
    {
      path: '/seminar/calendar',
      name: 'Планер',
      element: Calendar,
    },
    {
      path: '/order',
      name: 'Заказы',
      element: Order,
    },
    {
      path: '/resale',
      name: 'Продажи',
      element: Resale,
    },
    {
      path: '/resale/stats',
      name: 'Статистика продаж',
      element: ResaleStats,
    },
    {
      path: '/storage',
      name: 'Личный диск',
      element: Storage,
    },
    {
      path: '/storage/:accountId/:folderUuid',
      name: 'Личный диск',
      element: Storage,
    },
  ],
  MARKETING: [
    { path: '/', exact: true, name: <Translation>{(t) => t('home')}</Translation> },
    {
      path: '/dashboard',
      name: 'Планер',
      element: Calendar,
    },
    {
      path: '/user',
      name: 'Контакты',
      element: Account,
    },
    {
      path: '/user/:accountId/edit',
      name: 'Редактирование',
      element: AccountEdit,
    },
    {
      path: '/certificate',
      name: 'Сертификаты',
      element: Certificate,
    },
    {
      path: '/seminar/certificate',
      name: 'Участники мероприятия',
      element: SeminarCertificate,
    },
    {
      path: '/certificate/create',
      name: 'Подбор',
      element: CertificateEdit,
    },
    {
      path: '/seminar',
      name: 'Список мероприятий',
      element: Seminar,
    },
    {
      path: '/seminar/calendar',
      name: 'Планер',
      element: Calendar,
    },
  ],
  MASTER: [
    { path: '/', exact: true, name: <Translation>{(t) => t('home')}</Translation> },
    {
      path: '/dashboard',
      name: 'Профиль мастера',
      element: DashboardMaster,
    },
    {
      path: '/profile',
      name: 'Профиль',
      element: AccountEdit,
    },
    {
      path: '/order',
      name: 'Заказы',
      element: Order,
    },
    {
      path: '/tgchannels',
      name: 'Telegram каналы',
      element: TgChannels,
    },
  ],
  MANAGER_INSTRUCTOR: [
    { path: '/', exact: true, name: <Translation>{(t) => t('home')}</Translation> },
    {
      path: '/dashboard',
      name: 'Отчёт наставника',
      element: DashboardParent,
    },
    {
      path: '/report/instructor/top',
      name: 'Топ инструкторов',
      element: InstructorTop,
    },
    {
      path: '/report/download',
      name: 'Скачать отчёт',
      element: ReportDownload,
    },
    {
      path: '/instructors',
      name: 'Инструкторы',
      element: Instructors,
    },
    {
      path: '/user',
      name: 'Контакты',
      element: Account,
    },
    {
      path: '/user/:accountId/edit',
      name: 'Редактирование',
      element: AccountEdit,
    },
    {
      path: '/certificate',
      name: 'Сертификаты',
      element: Certificate,
    },
    {
      path: '/seminar/certificate',
      name: 'Участники мероприятия',
      element: SeminarCertificate,
    },
    {
      path: '/seminar',
      name: 'Список мероприятий',
      element: Seminar,
    },
    {
      path: '/seminar/calendar',
      name: 'Планер',
      element: Calendar,
    },
    {
      path: '/order',
      name: 'Заказы',
      element: Order,
    },
    {
      path: '/sales/stats',
      name: 'Статистика продаж 1С',
      element: SalesStats,
    },
    {
      path: '/resale',
      name: 'Продажи',
      element: Resale,
    },
    {
      path: '/resale/stats',
      name: 'Статистика продаж',
      element: ResaleStats,
    },
    {
      path: '/storage',
      name: 'Личный диск',
      element: Storage,
    },
    {
      path: '/storage/:accountId/:folderUuid',
      name: 'Личный диск',
      element: Storage,
    },
  ],
  MANAGER_MASTER: [
    { path: '/', exact: true, name: <Translation>{(t) => t('home')}</Translation> },
    {
      path: '/dashboard',
      name: 'Планер',
      element: Calendar,
    },
    {
      path: '/user',
      name: 'Контакты',
      element: Account,
    },
    {
      path: '/user/:accountId/edit',
      name: 'Редактирование',
      element: AccountEdit,
    },
    {
      path: '/certificate',
      name: 'Сертификаты',
      element: Certificate,
    },
    {
      path: '/seminar/certificate',
      name: 'Участники мероприятия',
      element: SeminarCertificate,
    },
    {
      path: '/seminar',
      name: 'Список мероприятий',
      element: Seminar,
    },
    {
      path: '/seminar/calendar',
      name: 'Планер',
      element: Calendar,
    },
    {
      path: '/order',
      name: 'Заказы',
      element: Order,
    },
    {
      path: '/sales/stats',
      name: 'Статистика продаж 1С',
      element: SalesStats,
    },
  ],
}

export default routes
